import type { SideBarDef } from 'ag-grid-community';

export const sidebarConfiguration = {
  defaultToolPanel: undefined, // so that the sidebar panel is initially closed
  toolPanels: [
    {
      id: 'columns',
      labelDefault: 'Columns',
      labelKey: 'columns',
      iconKey: 'columns',
      toolPanel: 'agColumnsToolPanel',
      toolPanelParams: {
        suppressPivotMode: true,
        suppressColumnFilter: true,
        suppressRowGroups: true,
        suppressValues: true,
      },
    },
  ],
} as const as SideBarDef;
